import { useState, useEffect, Dispatch, SetStateAction } from 'react';

import { Medlemskapstype } from '../api/medlemskapAPI';
import PaymentSummary from './PaymentSummary';
import Discount from './Discount';
import { validateDiscount } from '../api/discountAPI';
import { medlemskapstypeIsLivsvarig } from '../Utils';

interface PaymentSummaryWithDiscountProps {
    medlemskapstype?: Medlemskapstype;
    discountCode: string;
    discount: number;
    setDiscountCode: Dispatch<SetStateAction<string>>;
    setDiscount: Dispatch<SetStateAction<number>>;
}

function PaymentSummaryWithDiscount({
    medlemskapstype,
    discountCode,
    discount,
    setDiscountCode,
    setDiscount,
}: PaymentSummaryWithDiscountProps) {
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        setDiscountCode('');
        setDiscount(0);
    }, [medlemskapstype, setDiscount, setDiscountCode]);

    function updateDiscount(inputDiscount: string) {
        if (medlemskapstype && inputDiscount && inputDiscount !== '') {
            validateDiscount({
                discountCode: inputDiscount,
                originalPrice: medlemskapstype.price,
            }).then((response) => {
                if (response.status === 'ok') {
                    const codeIsValid = response.data.codeIsValid;

                    if (!codeIsValid) {
                        setShowError(true);
                        setDiscountCode('');
                    } else {
                        setShowError(false);
                        setDiscountCode(inputDiscount);
                        setDiscount(medlemskapstype.price - response.data.discountedPrice);
                    }
                }
            });
        }
    }

    const medlemskapIsLivsvarig = medlemskapstypeIsLivsvarig(medlemskapstype);

    return (
        <>
            {medlemskapstype && (
                <>
                    <PaymentSummary
                        medlemskapstype={medlemskapstype}
                        discountCode={discountCode}
                        discount={discount}
                        hideDescription={true}
                    />
                    {!discountCode && !medlemskapIsLivsvarig && (
                        <Discount onValidateClick={updateDiscount} hasError={showError} />
                    )}
                </>
            )}
        </>
    );
}

export default PaymentSummaryWithDiscount;
